import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var ProjectWorkLocationQuestion = /*#__PURE__*/function (_Component) {
  function ProjectWorkLocationQuestion(props) {
    var _this;
    _classCallCheck(this, ProjectWorkLocationQuestion);
    _this = _callSuper(this, ProjectWorkLocationQuestion, [props]);
    _this.state = {
      selectedWorkLocation: _this.props.workLocation,
      officeLocation: _this.props.officeLocation || '',
      specificOfficeDays: _this.props.specificOfficeDays,
      daysInOffice: _this.props.daysInOffice || ''
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.setUncertainDaysInOffice = _this.setUncertainDaysInOffice.bind(_this);
    _this.updateDaysInOffice = _this.updateDaysInOffice.bind(_this);
    _this.setSpecificOfficeDays = _this.setSpecificOfficeDays.bind(_this);
    return _this;
  }
  _inherits(ProjectWorkLocationQuestion, _Component);
  return _createClass(ProjectWorkLocationQuestion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var input = document.getElementById('project_office_location');
      var geocoder = new window.google.maps.places.Autocomplete(input);
      geocoder.setTypes(['(cities)']);
      window.google.maps.event.addDomListener(input, 'keydown', function (e) {
        if (e.keyCode === 13) {
          e.preventDefault();
        }
      });
      geocoder.addListener('place_changed', function () {
        _this2.setState({
          officeLocation: input.value
        });
      });
    }
  }, {
    key: "setUncertainDaysInOffice",
    value: function setUncertainDaysInOffice() {
      this.setState({
        daysInOffice: '',
        specificOfficeDays: false
      });
    }
  }, {
    key: "setSpecificOfficeDays",
    value: function setSpecificOfficeDays() {
      this.setState({
        specificOfficeDays: true
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var officeLocation = event.target.value;
      this.setState({
        officeLocation: officeLocation
      });
    }

    // Because of the way we are wrapping radio buttons with the labels styled as bootstrap buttons
    // the normal react onChange event on the inputs never fire. To work around it,
    // we have to handle an onClick on the label itself.
  }, {
    key: "changeWorkLocationFromLabel",
    value: function changeWorkLocationFromLabel(selectedWorkLocation) {
      this.setState({
        selectedWorkLocation: selectedWorkLocation
      });
    }
  }, {
    key: "updateDaysInOffice",
    value: function updateDaysInOffice(event) {
      this.setState({
        daysInOffice: event.target.value
      });
    }
  }, {
    key: "renderWorkLocationQuestion",
    value: function renderWorkLocationQuestion() {
      var _this3 = this;
      var workLocationCollection = this.props.workLocationCollection;
      var selectedWorkLocation = this.state.selectedWorkLocation;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        className: "required",
        htmlFor: "project_work_location"
      }, "Where will the consultant be based out of?"), /*#__PURE__*/React.createElement("div", {
        className: "form-group",
        id: "project_work_location"
      }, /*#__PURE__*/React.createElement("div", {
        className: "clf-check-radio-buttons",
        "data-toggle": "buttons"
      }, Object.entries(workLocationCollection).map(function (option) {
        return /*#__PURE__*/React.createElement("label", {
          className: "btn btn-default ".concat(selectedWorkLocation === option[0] ? 'active' : ''),
          htmlFor: "project_work_location_".concat(option[0]),
          key: "work_location_".concat(option[0]),
          onClick: function onClick() {
            return _this3.changeWorkLocationFromLabel(option[0]);
          }
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          value: option[0],
          defaultChecked: selectedWorkLocation === option[0],
          name: "project[work_location]",
          id: "project_work_location_".concat(option[0])
        }), option[1]);
      }))));
    }
  }, {
    key: "renderOfficeDaysQuestion",
    value: function renderOfficeDaysQuestion() {
      var selectedWorkLocation = this.state.selectedWorkLocation;
      if (!['office', 'both'].includes(selectedWorkLocation)) {
        // Only show this question if "Office" or "Office and Remote" are selected
        return null;
      }
      var uncertainOfficeDays = this.props.uncertainOfficeDays;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "project_office_days"
      }, "What is the minimum number of days per week that the consultant will be working in the office?"), /*#__PURE__*/React.createElement("div", {
        className: "form-group uncertainty-or-specified-amount",
        id: "project_office_days"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-inline"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        value: "",
        name: "project[office_days]",
        onChange: this.setSpecificOfficeDays,
        checked: this.state.specificOfficeDays
      }), /*#__PURE__*/React.createElement("div", {
        className: "input-group fifty-percent-width pl-5"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        value: this.state.daysInOffice,
        className: "form-control",
        onChange: this.updateDaysInOffice,
        name: "project[days_in_office]",
        id: "project_days_in_office",
        onFocus: this.setSpecificOfficeDays
      }), /*#__PURE__*/React.createElement("span", {
        className: "input-group-addon"
      }, " days / week"))), /*#__PURE__*/React.createElement("div", {
        className: "form-inline"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        value: uncertainOfficeDays,
        name: "project[office_days]",
        id: "project_office_days_na",
        onChange: this.setUncertainDaysInOffice,
        checked: !this.state.specificOfficeDays
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "project_office_days_na",
        className: "default-radio-label ps-3"
      }, "I'm not sure"))));
    }
  }, {
    key: "renderOfficeLocationQuestion",
    value: function renderOfficeLocationQuestion() {
      var selectedWorkLocation = this.state.selectedWorkLocation;
      // Only show this question if "Office" or "Office and Remote" are selected
      var required = ['office', 'both'].includes(selectedWorkLocation) ? 'required' : '';
      var officeLocation = this.state.officeLocation;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-group office-location"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "project_office_location",
        className: required
      }, "Where is your office located?"), /*#__PURE__*/React.createElement("input", {
        className: "form-control form-control--light",
        placeholder: "e.g. Boston",
        type: "text",
        value: officeLocation,
        name: "project[office_location]",
        id: "project_office_location",
        onChange: this.handleChange
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderWorkLocationQuestion(), this.renderOfficeDaysQuestion(), this.renderOfficeLocationQuestion());
    }
  }]);
}(Component);
ProjectWorkLocationQuestion.propTypes = {
  workLocation: PropTypes.string,
  workLocationCollection: PropTypes.shape({}).isRequired,
  uncertainOfficeDays: PropTypes.string.isRequired,
  daysInOffice: PropTypes.number,
  specificOfficeDays: PropTypes.bool.isRequired,
  officeLocation: PropTypes.string
};
ProjectWorkLocationQuestion.defaultProps = {
  workLocation: null,
  officeLocation: '',
  daysInOffice: ''
};
export default ProjectWorkLocationQuestion;